import Emoji from './Emoji';
import { EmojiType as ET } from './emojiManifest';

export type EmojiType = ET;

export default Emoji;
